
    import I18n from 'i18nObj';
    
      import 'translations/course_nickname_edit';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('course_nickname_edit');
  